export default "__VITE_ASSET__sv8LxdW4__"